exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pop-cover[data-v-21594855]{position:relative}.undo-popover[data-v-21594855]{position:absolute;right:32px;padding:10px;border-radius:4px;min-width:180px;bottom:-30px}", ""]);

// exports
